import { isNaN, toLower, isString } from 'lodash/fp';

export default (value) => {
  if (!value || !isString(value)) {
    return value;
  }

  const trimmedValue = value.trim();

  if (trimmedValue[0] === '{' || trimmedValue[0] === '[') {
    return JSON.parse(trimmedValue);
  }

  const number = parseFloat(trimmedValue);
  if (!isNaN(number)) {
    return number;
  }

  if (toLower(trimmedValue) === 'true') {
    return true;
  }
  if (toLower(trimmedValue) === 'false') {
    return false;
  }

  return trimmedValue;
};
